import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { Carousel } from '../carousel';

import commonStyles from './styles/styles.css';
import type { IProductDesignOption, TProduct } from './models';

export const ProductDesign: FC<TProduct> = ({
    Block,
    ProductCard,
    Text,
    analytics,
    card,
    carousel,
    className,
    config,
    flexibleAlfaCard,
    imagePosition = 'bottom',
    products,
    styles,
    title,
}) => {
    const stylesConfig = flexibleAlfaCard ? config.flexibleDesign : config.default;

    return (
        <Block className={className} notPadded styler={stylesConfig.block}>
            <Text
                className={carousel?.carouselTitle}
                styler={stylesConfig.title.styler}
                tag="div"
                view={stylesConfig.title.view}
            >
                {title}
            </Text>
            <Field<string>
                initialValue={products[0].value}
                name="productDesignCardId"
                render={({ input, meta }) => {
                    return (
                        <Carousel<IProductDesignOption>
                            containerClassName={cn(
                                styles.carouselContainer,
                                styles.external,
                                carousel?.containerClassName
                            )}
                            contentClassName={cn(
                                styles.carouselContent,
                                styles.external,
                                carousel?.contentClassName
                            )}
                            gridClassName={cn(
                                commonStyles[`carouselGrid${stylesConfig.gap}`],
                                commonStyles.external
                            )}
                            isPreselected
                            options={products}
                            renderCard={({ isSelected, onClick, option }) => (
                                <ProductCard
                                    key={option.value}
                                    backgroundColor={option.backgroundColor}
                                    borderRadius={card?.borderRadius}
                                    height={card?.height}
                                    imagePosition={imagePosition}
                                    imageSrc={option.image}
                                    isSelected={isSelected}
                                    onClick={(e, value) => {
                                        actions.onChange(input)(value);
                                        actions.updateAction(meta, { cardId: value });

                                        if (analytics?.click) {
                                            sendEvent(analytics.click);
                                        }

                                        onClick(e);
                                    }}
                                    subTitle={option.subTitle}
                                    title={option.title}
                                    value={option.value}
                                    width={card?.width}
                                />
                            )}
                        />
                    );
                }}
            />
        </Block>
    );
};
